module.exports = __webpack_public_path__ + "static/media/church-t1.8b6ed2ba.svg";